import * as yup from "yup";

const segmentItemSchema = yup.object({
  label: yup.string().required(),
  value: yup.string().required(),
  metaId: yup.string().required(),
});

export const validationSchema = yup
  .object({
    clearanceForwardingSegment: yup.array().of(segmentItemSchema).nullable(),
    transporterSegment: yup.array().of(segmentItemSchema).nullable(),
    driverSegment: yup.array().of(segmentItemSchema).nullable(),
  })
  .test("at-least-one", "At least one option must be selected", function (value) {
    const {
      clearanceForwardingSegment,
      transporterSegment,
      driverSegment,
    } = value || {};

    const isValid =
      (clearanceForwardingSegment?.length ?? 0) > 0 ||
      (transporterSegment?.length ?? 0) > 0 ||
      (driverSegment?.length ?? 0) > 0;

    if (!isValid) {
      return this.createError({
        path: "formError", // ✅ Use a custom field name
        message: "At least one option must be selected from any segment",
      });
    }

    return true;
  });
